import { Box, Card, CardContent, CardHeader, Grid, Typography } from '@mui/material';
import { useAppDispatch, useAppSelector } from '@src/app/hooks/store';
import { setTransactionsFilter } from '@src/app/store/reducers/transactions';
import { selectTransactions } from '@src/app/store/reducers/transactions/selectors';
import { numberFormatterDollar } from '@src/app/utils/GenericUtils';
import { FC } from 'react';
import { MonetizationOnOutlined } from '@mui/icons-material';

export interface TransactionCardProps {
  name: string;
  value: number;
  filterValue: string;
  filterIds: number[];
  icon?: FC;
}

const TransactionCard: FC<TransactionCardProps> = ({ name, value, filterIds, filterValue }: TransactionCardProps): JSX.Element => {
  const { filteredItem } = useAppSelector(selectTransactions);
  const dispatch = useAppDispatch();

  const selected = filteredItem === filterValue;

  const handleFilterBy = () => {
    dispatch(setTransactionsFilter({ name: filterValue, ids: filterIds }));
  };

  return (
    <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
      <Card
        onClick={handleFilterBy}
        elevation={selected ? 1 : 0}
        sx={{
          borderRadius: '24px',
          border: '1px solid #E9E9E9',
          ':hover': {
            cursor: 'pointer',
          },
        }}
      >
        <CardHeader
          title={
            <Box display="flex" alignItems="center" gap={1}>
              <MonetizationOnOutlined sx={{ color: '#222222' }} />
              <Typography fontSize={16} color="#222222">
                {name}
              </Typography>
            </Box>
          }
          titleTypographyProps={{
            align: 'center',
            fontWeight: 700,
            fontSize: 14,
          }}
        />
        <CardContent sx={{ alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: 20,
              color: '#222222',
            }}
          >
            {numberFormatterDollar(value)}
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default TransactionCard;
